import { FetchStatus } from '@powdr/constants';

import { LEADERBOARD_PENDING, LEADERBOARD_SUCCESS, LEADERBOARD_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LEADERBOARD_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case LEADERBOARD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case LEADERBOARD_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
